import { Params } from '@angular/router';
import { ActivityType, AssetDto, GalleryDto } from '@picflow/types';

export type activityOutputContext = 'tenant' | 'gallery';

export type activityType =
  | 'asset.liked'
  | 'asset.approved'
  | 'asset.rejected'
  | 'asset.unapproved'
  | 'asset.unrejected'
  | 'asset.color_label_red'
  | 'asset.color_label_orange'
  | 'asset.color_label_blue'
  | 'asset.color_label_purple'
  | 'asset.color_label_green'
  | 'asset.removed_color_label'
  | 'comment.created'
  | 'gallery-download.created'
  | 'asset-download.created'
  | 'multi-asset-download.created'
  | 'asset-annotation.created'
  | 'gallery-view.created';

export const groupingFields = {
  'asset.liked': ['assets', 'people'],
  'asset.approved': ['assets'],
  'asset.rejected': ['assets'],
  'asset.unapproved': ['assets'],
  'asset.unrejected': ['assets'],
  'asset.color_label_red': ['assets'],
  'asset.color_label_orange': ['assets'],
  'asset.color_label_blue': ['assets'],
  'asset.color_label_purple': ['assets'],
  'asset.color_label_green': ['assets'],
  'asset.removed_color_label': ['assets'],
  'comment.created': ['assets', 'people'],
  'asset-annotation.created': ['assets', 'people'],
  'gallery-download.created': ['people'],
  'asset-download.created': ['people', 'assets'],
  'multi-asset-download.created': ['people'],
  'gallery-view.created': ['people'],
};

export interface GroupTextItem {
  content: string;
  type: 'text' | 'approved' | 'rejected' | 'people' | 'assets' | 'gallery'; // more to add
  subType?: 'gallery';
}

export interface ActivityGroupPerson {
  name: string;
  id: string;
  avatar_url?: string;
  initials: string; // guest or user
  type: 'guest' | 'user';
  anonymous_id?: string;
}

export interface ActivityGroup {
  startTime: number;
  endTime: number;
  anonymousUserCount: number;
  people: ActivityGroupPerson[];
  assetIds: string[];
  assets: AssetDto[];
  gallery: GalleryDto;
  deletedGalleryId?: string;
  type: activityType;
  text: GroupTextItem[];
  items: ActivityItem[];
  link?: string[];
  fragment?: string;
  queryParams?: { [key: string]: string };
  icon: string;
  iconColor: string;
  grouping: 'people' | 'assets';
}

export interface ActivityItem {
  id: string;
  time: number;
  context: {
    gallery: GalleryDto;
    deletedGalleryId?: string;
    assetId: string;
    assetIds: string[];
    person?: {
      id: string;
      name: string;
      initials: string;
      type: 'guest' | 'user';
    };
  };
  fragment?: string;
  queryParams?: { [key: string]: string };
  type: activityType;
  rawType: string;
}

export interface ConvertedActivity {
  id: string;
  time: number;
  context: {
    gallery: GalleryDto;
    assetId: string;
    assetIds: string[];
    person: ActivityGroupPerson;
    deletedGalleryId?: string;
  };
  type: activityType;
  rawType: ActivityType;
  fragment: string;
  queryParams: Params;
}

export interface ActivityDay {
  name: string;
  timestamp: number;
  activityItems: ConvertedActivity[];
}

export interface ActivityGroupDay {
  name: string;
  timestamp: number;
  activityGroups: ActivityGroup[];
}

export type getActivityResponse = Promise<{ days: ActivityGroupDay[]; isMore: boolean }>;
